module.exports = __webpack_public_path__ + "img/espaço-11.d8baf31d.jpeg";